var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Translate } from "../I18N";
import Modal from "./Modal";

class ConfirmModal extends Component {
  render() {
    return /*#__PURE__*/(
      _jsx(Modal, { isOpen: this.props.isOpen, type: this.props.type }, void 0, /*#__PURE__*/
      _jsx(Modal.Body, {}, void 0, /*#__PURE__*/
      _jsx("h4", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, this.props.title)
      ), /*#__PURE__*/
      _jsx("p", {}, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, this.props.message)
      )
      ), /*#__PURE__*/

      _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: "btn btn-default cancel-button",
        onClick: this.props.onCancel }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Cancel")
      ), /*#__PURE__*/
      _jsx("button", {
        type: "button",
        className: `btn confirm-button btn-${this.props.type}`,
        onClick: this.props.onAccept }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Accept")
      )
      )
      ));

  }
}

ConfirmModal.defaultProps = {
  isOpen: true,
  message: 'Are you sure you want to continue?',
  title: 'Confirm action',
  type: 'danger'
};










export default ConfirmModal;